export default {"src":"/_next/static/media/LOGO.97b63e7a.svg","height":23,"width":171,"blurWidth":0,"blurHeight":0};